const ShopMoneyFormatFunc = function(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const format = window.money_format_without_html
  const formatString = format || window.theme.moneyFormat || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g, 
      '$1' + thousands
    );
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
  }

  return formatString.replace(placeholderRegex, value)
    // 移除末尾是0的小数
    // .replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
};

/*
 1、生成了自定义的arrow控制器
 2、处理padding.right设置时，最后一个item有空白
 使用方式：
 class xx extends HTMLElement {
   constructor() {
     super()
     this.splide = ...;
     this.splideControl = new SplideControl(this.splide)
     // 如果你需要自定义arrow
     this.initArrows(this.querySelector('.splide'))
     // 如果需要
     this.onSplideReady(() => ())
     this.onSplideMove(() => ())
     // 最后挂载
     this.splide.mount()
   }
 }
 */
class SplideControl {
  constructor(splide) {
    this.splide = splide

    // 当设置了padding.right后，滚动到最后一个item时，消除右侧的空白区域
    // .splide__track需要给padding设置css过度效果transition: padding .3s ease;
    this.splide.on('move', () => {
      const track = this.splide.Components.Elements.track
      const currentPadding = this.splide.options.padding
      if (currentPadding) {
        if (this.splide.index === this.splide.Components.Controller.getEnd()) {
          track.style.paddingRight = '0'
          track.style.paddingLeft = currentPadding.right + 'px'
        } else {
          track.style.paddingLeft = '0'
          track.style.paddingRight = currentPadding.right + 'px'
        }
      }
      this.updateArrowState()
      this.onSplideMoveListener && this.onSplideMoveListener()
    })
    this.splide.on('ready', () => {
      this.updateArrowState()
      this.onSplideReadyListener && this.onSplideReadyListener()
    })
  }

  initArrows(container) {
    this.arrowButtonPrev = document.createElement('button')
    this.arrowButtonPrev.classList.add('slider-arrow', 'type-float')
    this.arrowButtonPrev.setAttribute('dir', 'prev')
    this.arrowButtonPrev.innerHTML = '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z" fill="currentColor"></path></svg>'
    container.appendChild(this.arrowButtonPrev)

    this.arrowButtonNext = document.createElement('button')
    this.arrowButtonNext.classList.add('slider-arrow', 'type-float')
    this.arrowButtonNext.setAttribute('dir', 'next')
    this.arrowButtonNext.innerHTML = '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z" fill="currentColor"></path></svg>'
    container.appendChild(this.arrowButtonNext)

    const onArrowClickListener = this.onArrowClick.bind(this)
    this.arrowButtonPrev.addEventListener('click', onArrowClickListener)
    this.arrowButtonNext.addEventListener('click', onArrowClickListener)
  }

  onArrowClick(e) {
    const btn = e.target.closest('button')
    if (btn.getAttribute('dir') == 'prev') {
      this.splide.go('<')
    } else {
      this.splide.go('>')
    }
  }

  updateArrowState() {
    if (this.arrowButtonPrev) {
      this.arrowButtonPrev.removeAttribute('disabled')
      this.arrowButtonNext.removeAttribute('disabled')
      if (this.splide.index == 0) {
        this.arrowButtonPrev.setAttribute('disabled', '')
      } else if (this.splide.index == this.splide.Components.Controller.getEnd()) {
        this.arrowButtonNext.setAttribute('disabled', '')
      }
    }
  }

  onSplideReady(callback) {
    this.onSplideReadyListener = callback
  }

  onSplideMove(callback) {
    this.onSplideMoveListener = callback
  }
}


class JxsButton extends HTMLButtonElement {
  constructor() {
    super()
    const text = this.innerHTML
    this.innerHTML = ''

    const textSpan = document.createElement('span')
    textSpan.innerHTML = text
    textSpan.classList.add('btn-text')
    this.appendChild(textSpan)

    const loadingSpan = document.createElement('span')
    loadingSpan.innerHTML = '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3 0.1 19.9-16 36-35.9 36z" p-id="6698" fill="currentColor"></path></svg>'
    loadingSpan.classList.add('btn-loading', 'loading-spinner')
    this.appendChild(loadingSpan)
  }

  setLoading(loading) {
    if (loading) {
      this.setAttribute('loading', '')
    } else {
      this.removeAttribute('loading')
    }
  }

  isClickable() {
    return !this.isLoading() && !this.hasAttribute('disabled')
  }

  isLoading() {
    return this.hasAttribute('loading')
  }

  setText(text) {
    this.querySelector('.btn-text').textContent = text
  }
}
customElements.define('jxs-button', JxsButton, { extends: 'button' });


class JxsFeaturedCategory extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    new Splide(this.querySelector('.splide'), {
      arrows: false,
      pagination: false,
      destory: true,
      breakpoints: {
        767: {
          destory: false,
          perPage: 1,
          gap: 20,
          padding: {
            right: '70px'
          }
        }
      }
    }).mount()
  }
}
customElements.define('jxs-featured-category', JxsFeaturedCategory);


class JxsReviewProduct extends HTMLElement {
  constructor() {
    super()

    const onContentMouseMoveListener = this.onContentMouseMove.bind(this)
    const onContentMouseLeaveListener = this.onContentMouseLeave.bind(this)
    this.querySelectorAll('.review-card__content').forEach(content => {
      content.addEventListener('mousemove', onContentMouseMoveListener)
      content.addEventListener('mouseleave', onContentMouseLeaveListener)
    })

    this.tooltipMaps = {}
    this.querySelectorAll('.jxs-review-product__content-tooltip').forEach(tp => {
      this.tooltipMaps[tp.dataset.blockId] = tp
      document.body.appendChild(tp)
    })

    this.init()
  }

  init() {
    this.splide = new Splide(this.querySelector('.splide'), {
      arrows: false,
      pagination: false,
      gap: 16,
      perPage: 4,
      breakpoints: {
        767: {
          perPage: 1,
          padding: { right: 70 }
        },
        980: {
          perPage: 2
        },
        1024: {
          perPage: 3
        }
      }
    })

    this.splideControl = new SplideControl(this.splide)
    this.splideControl.initArrows(this.querySelector('.splide'))
    this.splide.mount()
  }

  

  onContentMouseMove(e) {
    const tp = this.tooltipMaps[e.target.dataset.blockId]
    if (tp) {
      tp.style.display = 'block'
      tp.style.left = (e.clientX + window.scrollX + 10) + 'px'
      tp.style.top = (e.clientY + window.scrollY + 10) + 'px'
    }
  }

  onContentMouseLeave(e) {
    const tp = this.tooltipMaps[e.target.dataset.blockId]
    if (tp) {
      tp.style.display = 'none'
    }
  }
}
customElements.define('jxs-review-product', JxsReviewProduct);

class JxsReviewTabDetail extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    document.addEventListener('click', this.#onBadgeClick, true)
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#onBadgeClick, true)
  }

  #onBadgeClick = (e) => {
    const badge = e.target.closest('.jdgm-preview-badge')
    if (!badge || !badge.closest('.product-shop')) return

    e.preventDefault()
    e.stopImmediatePropagation()

    const tabDetail = this.closest('jxs-product-tab-detail')
    const expandableItem = this.closest('.expandable-item')
    tabDetail?.activateTab(expandableItem?.dataset.index)
  }
}
customElements.define('jxs-review-tab-detail', JxsReviewTabDetail);

class JxsProductTabDetail extends HTMLElement {
  constructor() {
    super()
    this.style.setProperty('--header-height', '0px')
    this.init()

    const onTabItemClickListener = this.onTabItemClick.bind(this)
    this.querySelectorAll('.tab-list__item').forEach(item => {
      item.addEventListener('click', onTabItemClickListener)
    })

    const onMobileTabItemClickListener = this.onMobileTabItemClick.bind(this)
    this.querySelectorAll('.expandable-item .expand-title').forEach(title => {
      title.addEventListener('click', onMobileTabItemClickListener)
    })

    // 导航栏是动态插入到DOM的，因此需要监控这个元素，等待其插入到DOM再监控高度
    const stickyHeaderObserver = new MutationObserver((mutations, observer) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          if (document.getElementById('sticky-wrapper')) {
            this.watchStickyHeaderHeight()
            stickyHeaderObserver.disconnect();
          }
        }
      }
    });
    stickyHeaderObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    setTimeout(() => {
      stickyHeaderObserver.disconnect();
    }, 10 * 1000)
  }

  // 监控导航栏高度，为栏目的sticky设置top
  watchStickyHeaderHeight() {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.style.setProperty('--header-height', entry.contentRect.height + 'px')
      }
    });
    observer.observe(document.querySelector('.sticky-wrapper.is-sticky .wrapper-navigation'));
  }

  init() {
    new Splide(this.querySelector('.splide.tab-list'), {
      autoWidth: true,
      arrows: false,
      pagination: false
    }).mount()
  }

  onTabItemClick(e) {
    this.activateTab(e.target.dataset.index)
  }

  activateTab(index) {
    if (index == null || index === '') return

    this.querySelector('.tab-list__item.actived')?.classList.remove('actived')
    this.querySelector(`.tab-list__item[data-index="${index}"]`)?.classList.add('actived')
    this.querySelector('.expandable-item.actived')?.classList.remove('actived')
    const expandableItem = this.querySelector(`.expandable-item[data-index="${index}"]`)
    if (!expandableItem) return
    expandableItem.classList.add('actived')
    expandableItem.setAttribute('open', '')
    this.scrollToTab(expandableItem)
  }

  scrollToTab(expandableItem) {
    const isMobileExpand = window.innerWidth <= 767 && this.classList.contains('mobile-layout-expand')
    const targetEl = isMobileExpand ? expandableItem : this.closest('.shopify-section')
    if (!targetEl) return

    const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY
    let headerHeight
    if (window.innerWidth > 1200) {
      const header = document.querySelector('.sticky-wrapper.is-sticky .wrapper-navigation')
      headerHeight = header ? header.getBoundingClientRect().height : 0
    } else if (window.innerWidth >= 768) {
      headerHeight = 102
    } else {
      headerHeight = 93
    }

    window.scrollTo({
      top: Math.max(0, targetPosition - headerHeight),
      behavior: 'smooth'
    })
  }

  onMobileTabItemClick(e) {
    const expandableItem = e.target.closest('.expandable-item')
    if (expandableItem.hasAttribute('open')) {
      expandableItem.removeAttribute('open')
    } else {
      expandableItem.setAttribute('open', '')
    }
  }
}
customElements.define('jxs-product-tab-detail', JxsProductTabDetail);

class JxsSofewareUpdateProduct extends HTMLElement {
  constructor() {
    super()
    this.querySelector('.add2cart').addEventListener('click', this.onAdd2CartClick.bind(this))
  }

  onAdd2CartClick(e) {
    const btn = e.target.closest('button')
    if (btn.isLoading()) {
      return
    }
    btn.setLoading(true)
    const formData = {
      items: [{
        id: btn.dataset.variantId,
        quantity: 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.description);
        });
      }
      return response.json();
    })
    .then(data => {
      ella.getPopupShoppingCart(true)
    })
    .catch(error => {
      console.error('添加失败:', error.message);
    })
    .finally(() => {
      btn.setLoading(false)
    })
  }
}
customElements.define('jxs-sofeware-update-product', JxsSofewareUpdateProduct);


class JxsIconTextContainer extends HTMLElement {
  constructor() {
    super()
    let nextElement = this.nextElementSibling;
    let hasChild = false
    while (nextElement && nextElement.classList.contains('icon-text__item')) {
      const itemToMove = nextElement;
      nextElement = nextElement.nextElementSibling;
      this.appendChild(itemToMove);
      hasChild = true
    }
    if (!hasChild) {
      this.remove()
    }
  }
}
customElements.define('jxs-icon-text-container', JxsIconTextContainer);

class JxsShippingInfo extends HTMLElement {
  constructor() {
    super();
    // 默认值设为 "3-7"（示例）
    this.daysRange = this.dataset.daysForUserCountry;
    this.dateRangeElement = this.querySelector('.date-range');
    this.updateDateRange();

    this.onVariantSelectedListener = this.onVariantSelected.bind(this)

    if (this.getAttribute('status') == 'pre-product') {
      const preProduct = this.querySelector('.pre-product')
      const text = preProduct.dataset.text // this is a [date]
      const date = preProduct.dataset.date // 2026-02-12
      preProduct.innerHTML = text.replace('[date]', `<span class="date">${date}</span>`)
    }
  }

  connectedCallback() {
    document.addEventListener('variantSelected', this.onVariantSelectedListener)
  }

  disconnectedCallback() {
    document.removeEventListener('variantSelected', this.onVariantSelectedListener)
  }

  updateDateRange() {
    try {
      const [minDays, maxDays] = this.daysRange.split('-').map(Number);
      const today = new Date();
      const startDate = new Date(today);
      startDate.setDate(today.getDate() + minDays);
      const endDate = new Date(today);
      endDate.setDate(today.getDate() + maxDays);
      const formattedStartDate = this.formatDate(startDate);
      const formattedEndDate = this.formatDate(endDate);
      this.dateRangeElement.textContent = `${formattedStartDate} – ${formattedEndDate}`;
    } catch (e) {
      this.dateRangeElement.textContent = 'Unknow'
    }
  }

  formatDate(date) {
    const options = { weekday: 'short', month: 'short', day: '2-digit' };
    return date.toLocaleDateString('en-US', options);
  }

  onVariantSelected(e) {
    if (this.getAttribute('status') != 'pre-product') {
      const variant = e.detail.variant
      if (variant) {
        if (variant.available) {
          this.setAttribute('status', 'default')
        } else {
          this.setAttribute('status', 'sold-out')
        }
      }
    }
  }
}
customElements.define('jxs-shipping-info', JxsShippingInfo);

class JxsModal extends HTMLElement {
  constructor() {
    super()
    this.modalId = this.getAttribute('modal-id')
    
    const onModalOpenListener = this.openModal.bind(this)
    document.querySelectorAll(`[jxs-modal="${this.modalId}"]`).forEach(open => {
      open.addEventListener('click', onModalOpenListener)
    })

    const onModalCloseListener = this.closeModal.bind(this)
    this.querySelector('.real-modal-top svg').addEventListener('click', onModalCloseListener)
    this.addEventListener('click', onModalCloseListener)
    this.querySelector('.real-modal').addEventListener('click', (e) => {
      e.stopPropagation()
    })
  }

  openModal() {
    this.style.display = 'flex'
    if (!document.body.classList.contains('js-no-scroll')) {
      document.body.classList.add('js-no-scroll')
    }
  }

  closeModal(e) {
    e.stopPropagation()
    this.style.display = 'none'
    document.body.classList.remove('js-no-scroll')
  }
}
customElements.define('jxs-modal', JxsModal);

class JxsRecentlyViewedProducts extends HTMLElement {
  constructor() {
    super()
    this.onAdd2CartClickListener = this.onAdd2CartClick.bind(this)
    this.initSplide()
    this.renderProducts()
  }

  initSplide() {
    this.splide = new Splide(this.querySelector('.splide'), {
      mediaQuery: 'min',
      gap: 30,
      pagination: false,
      arrows: false,
      breakpoints: {
        0: {
          perPage: parseInt(this.dataset.columnsMobile)
        },
        768: {
          perPage: parseInt(this.dataset.columnsTablet)
        },
        1200: {
          perPage: parseInt(this.dataset.columnsDesktop)
        }
      }
    })
    this.splideControl = new SplideControl(this.splide)
    this.splideControl.initArrows(this.querySelector('.splide'))
    this.splide.mount()
  }

  onAdd2CartClick(e) {
    const btn = e.target.closest('button')
    if (!btn.isClickable()) {
      return
    }
    btn.setLoading(true)
    const formData = {
      items: [{
        id: btn.dataset.id,
        quantity: 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.description);
        });
      }
      return response.json();
    })
    .then(data => {
      ella.getPopupShoppingCart(true)
    })
    .catch(error => {
      console.error('添加失败:', error.message);
    })
    .finally(() => {
      btn.setLoading(false)
    })
  }

  renderProducts() {
    this.getRecentlyViewedProducts(5)
      .then(products => {
        this.splide.remove(() => true)
        if (products.length == 0) {
          this.closest('.shopify-section').remove()
        } else {
          for (const p of products) {
            const card = this.createProductCard(p)
            const slide = document.createElement('li')
            slide.classList.add('splide__slide')
            slide.appendChild(card)
            this.splide.add(slide)
            this.loadProductReviewByJudgeMe(p.id, card.querySelector('.rating'))
            card.querySelector('button.add2cart')?.addEventListener('click', this.onAdd2CartClickListener)
          }
          if (products.length <= 1) {
            this.querySelectorAll('.slider-arrow').forEach(item => {
              item.style.display = 'none'
            })
          }
        }
      })
  }

  createProductCard(product) {
    const tmpl = `
      <div class="product-card product-item">
        <a href="${product.url}" class="product-card__media product-image">
          <img src="${product.featured_image}" >
          <div class="product-label"><strong class="label sale-label"></strong></div>
        </a>
        <div class="product-card__bottom">
          <a href="${product.url}" class="product-title truncate truncate-line-3">${product.title}</a>
          <div class="rating"></div>
          <div class="price price-box">
            <span class="price-compare old-price"></span>
            <span class="price-sale special-price"></span>
          </div>
        </div>
        <div class="product-card__action">
          <div class="buy-bar action">
            <button is="jxs-button" class="add2cart btn buy-btn" data-id="">ADD TO CART</button>
            <a href="${product.url}" class="btn buy-btn">SELECT OPTION</a>
          </div>
          <div class="comparable-custom-action">
            <input class="add-to-comparable" type="checkbox" id="add-to-comparable-checkbox_${product.handle}" data-product="${product.handle}" />
            <label for="add-to-comparable-checkbox_${product.handle}">Add to compare</label>
          </div>
        </div>
      </div>
    `;
    const fragment = document.createRange().createContextualFragment(tmpl);
    const card = fragment.firstElementChild;
    let fromLabel = ''
    if (!product.price_varies) {
      fromLabel = '<em>from</em>'
    }
    card.querySelector('.price-sale').innerHTML = fromLabel + ShopMoneyFormatFunc(product.price_min)
    if (product.compare_at_price_min > product.price_min) {
      card.querySelector('.price-compare').textContent = ShopMoneyFormatFunc(product.compare_at_price_min)
      const percent = (product.compare_at_price_min - product.price_min) / product.compare_at_price_min * 100
      card.querySelector('.sale-label').textContent = Math.round(percent) + '%'
    } else {
      card.querySelector('.price-compare').remove()
      card.querySelector('.sale-label').remove()
    }

    const add2cartButton = card.querySelector('.buy-bar button')
    if (product.variants[0].title == 'Default Title') {
      card.querySelector('.buy-bar a').remove()
      add2cartButton.dataset.id = product.variants[0].id
      if (product.variants[0].available == false) {
        add2cartButton.setText('SOLD OUT')
        add2cartButton.setAttribute('disabled', '')
      }
    } else {
      add2cartButton.remove()
    }

    return card
  }

  /*
    从cookie里获取最近浏览过的产品handle。
    数据来自原模版的代码：Shopify.Products.recordRecentlyViewed()
   */
  getRecentlyViewedProducts(limit = 3) {
    const cookieName = "shopify_recently_viewed";

    const getProductIds = () => {
        const cookieValue = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${cookieName}=`))
            ?.split('=')[1];
        
        if (!cookieValue) return [];
        return decodeURIComponent(cookieValue).split(' ');
    };

    const fetchProductInfo = (productId) => {
        // 跳过无效 ID
        if (productId.includes(' ') || !/^[\w-]+$/.test(productId)) {
            return Promise.resolve(null);
        }

        const url = `${window.router || ''}/products/${encodeURIComponent(productId)}.js`;
        return fetch(url, { cache: 'no-store' })
            .then(response => {
                if (!response.ok) throw new Error(`Invalid product ID: ${productId}`);
                return response.json();
            })
            .catch(error => {
                console.error(error);
                return null;
            });
    };

    // 主逻辑
    return new Promise((resolve) => {
        const productIds = getProductIds();
        if (productIds.length === 0) {
            resolve([]);
            return;
        }

        const limitedIds = productIds.slice(0, limit);
        const productPromises = limitedIds.map(fetchProductInfo);

        Promise.all(productPromises)
            .then(products => resolve(products.filter(Boolean)))
            .catch(error => {
                console.error("Error fetching products:", error);
                resolve([]);
            });
    });
  }

  loadProductReviewByJudgeMe(productId, productRatingContainer) {
    const url = `https://api.judge.me/api/v1/widgets/preview_badge?api_token=F5x8P4Cz-7o9FIZfQge0ea5FhPs&shop_domain=${this.dataset.shopDomain}&external_id=${productId}`
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then(data => {
        productRatingContainer.innerHTML = data?.badge || '';
        if (productRatingContainer.firstElementChild) {
          productRatingContainer.firstElementChild.style.display = 'block'
        }
      })
  }
}
customElements.define('jxs-recently-viewed-products', JxsRecentlyViewedProducts);

class JxsTabProductList extends HTMLElement {
  constructor() {
    super()

    const onTabItemClickListener = this.onTabItemClick.bind(this)
    this.querySelectorAll('.tab-item').forEach(item => {
      item.addEventListener('click', onTabItemClickListener)
    })
  }

  onTabItemClick(e) {
    const index = e.target.dataset.index
    this.querySelector('.tab-item.actived')?.classList.remove('actived')
    e.target.classList.add('actived')

    this.querySelector('.product-panel.actived')?.classList.remove('actived')
    this.querySelector(`.product-panel[data-index="${index}"]`)?.classList.add('actived')
  }
}
customElements.define('jxs-tab-product-list', JxsTabProductList);

class JxsMegaTabProduct extends HTMLElement {
  constructor() {
    super();
    
    // Initialize media query listener
    this.mobileMedia = window.matchMedia('(max-width: 1199px)');
    this.mobileMedia.addEventListener('change', this.onMediaQueryChange.bind(this));
    
    // Get the switching mode from attribute (default to 'click')
    this.switchMode = this.getAttribute('switch-mode') || 'click';
    
    // Bind event listeners
    this.onTabItemClick = this.onTabItemClick.bind(this);
    this.onTabItemHover = this.onTabItemHover.bind(this);
    this.onMediaQueryChange = this.onMediaQueryChange.bind(this);
    
    this.initEventListeners();
    this.activateMinPositionTab();
  }
  
  initEventListeners() {
    const tabHandles = this.querySelectorAll('.tab-list .tab-handle');
    
    // Always add click listeners
    tabHandles.forEach(item => {
      item.addEventListener('click', this.onTabItemClick);
    });
    
    // Add hover listeners if in hover mode and not mobile
    if (this.switchMode === 'hover' && !this.mobileMedia.matches) {
      tabHandles.forEach(item => {
        item.addEventListener('mouseenter', this.onTabItemHover);
      });
    }
  }

  activateMinPositionTab() {
    const tabItems = Array.from(this.querySelectorAll('.tab-list li'));
    if (tabItems.length === 0) return;

    // Find the item with minimum data-position value
    const minPositionItem = tabItems.reduce((minItem, currentItem) => {
      const currentPos = parseInt(currentItem.dataset.position) || 0;
      const minPos = parseInt(minItem.dataset.position) || 0;
      return currentPos < minPos ? currentItem : minItem;
    }, tabItems[0]);

    // Find the .tab-handle within this item
    const tabHandle = minPositionItem.querySelector('.tab-handle');
    if (tabHandle) {
      this.switchTab(tabHandle);
    }
  }
  
  // Handle tab switching via click
  onTabItemClick(e) {
    const item = e.target.closest('.tab-handle');
    this.switchTab(item);
  }
  
  // Handle tab switching via hover (only on desktop)
  onTabItemHover(e) {
    if (this.mobileMedia.matches) return;
    const item = e.target.closest('.tab-handle');
    this.switchTab(item);
  }
  
  // Common tab switching logic
  switchTab(item) {
    if (!item) return;
    
    if (this.mobileMedia.matches) {
      const isCurrent = item.classList.contains('actived');
      if (isCurrent) {
        item.classList.remove('actived');
        this.querySelector(`.tab-panel.mobile[data-index="${item.dataset.index}"]`)?.classList.remove('actived');
      } else {
        item.classList.add('actived');
        this.querySelector(`.tab-panel.mobile[data-index="${item.dataset.index}"]`)?.classList.add('actived');
      }
    } else {
      this.querySelector('.tab-list .tab-handle.actived')?.classList.remove('actived');
      item.classList.add('actived');
      this.querySelector('.tab-panel.desktop.actived')?.classList.remove('actived');
      this.querySelector(`.tab-panel.desktop[data-index="${item.dataset.index}"]`)?.classList.add('actived');
    }
  }
  
  onMediaQueryChange() {
    // Remove all active panels
    this.querySelectorAll('.tab-panel.actived').forEach(item => {
      item.classList.remove('actived');
    });
    
    // Find or set the active handle
    const activedHandle = this.querySelector('.tab-handle.actived');
    if (!activedHandle) {
      this.querySelector('.tab-handle')?.classList.add('actived');
    }
    const index = activedHandle ? activedHandle.dataset.index : '1';
    
    // Set the correct panel active based on media query
    if (this.mobileMedia.matches) {
      this.querySelector(`.tab-panel.mobile[data-index="${index}"]`)?.classList.add('actived');
    } else {
      this.querySelector(`.tab-panel.desktop[data-index="${index}"]`)?.classList.add('actived');
    }
    
    // Update hover event listeners based on media query and mode
    const tabHandles = this.querySelectorAll('.tab-list .tab-handle');
    tabHandles.forEach(item => {
      item.removeEventListener('mouseenter', this.onTabItemHover);
    });
    
    if (this.switchMode === 'hover' && !this.mobileMedia.matches) {
      tabHandles.forEach(item => {
        item.addEventListener('mouseenter', this.onTabItemHover);
      });
    }
  }
  
  // Observe attribute changes
  static get observedAttributes() {
    return ['switch-mode'];
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'switch-mode') {
      this.switchMode = newValue || 'click';
      
      // Update event listeners when mode changes
      const tabHandles = this.querySelectorAll('.tab-list .tab-handle');
      tabHandles.forEach(item => {
        item.removeEventListener('mouseenter', this.onTabItemHover);
      });
      
      if (this.switchMode === 'hover' && !this.mobileMedia.matches) {
        tabHandles.forEach(item => {
          item.addEventListener('mouseenter', this.onTabItemHover);
        });
      }
    }
  }
}

customElements.define('jxs-mega-tab-product', JxsMegaTabProduct);


class JxsLanguageCurrency extends HTMLElement {
  constructor() {
    super()
    const link = this.findMostMatchingLink()
    const current = this.querySelector('.current')
    if (link) {
      const img = link.querySelector('img')
      if (img) {
        current.appendChild(img.cloneNode())
      }
      const currency = link.querySelector('.currency-text')
      if (currency) {
        current.appendChild(currency.cloneNode(true))
      }
    } else {
      current.innerHTML = 'Lang'
    }
  }

  findMostMatchingLink() {
    // 获取当前页面的URL
    const currentUrl = window.location.href;
    
    // 获取页面上所有的a标签
    const links = this.querySelectorAll('.lang-selector a')
    
    let bestMatch = null;
    let bestScore = -1;
    
    // 遍历所有a标签
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const href = link.href;
      
      if (!href) continue;
      
      // 计算当前URL和a标签href的匹配度
      let score = 0;
      
      // 方案1：完全匹配（得分最高）
      if (href === currentUrl) {
        return link; // 直接返回完全匹配的链接
      }
      
      // 方案2：比较URL路径部分
      const currentUrlObj = new URL(currentUrl);
      let linkUrlObj;
      
      try {
        linkUrlObj = new URL(href);
      } catch (e) {
        // 如果href是相对路径，尝试构造完整URL
        try {
          linkUrlObj = new URL(href, currentUrlObj.origin);
        } catch (e) {
          continue; // 无效的URL，跳过
        }
      }
      
      // 比较协议和域名
      if (currentUrlObj.protocol === linkUrlObj.protocol && 
          currentUrlObj.hostname === linkUrlObj.hostname) {
        score += 2; // 协议和域名匹配加分
      }
      
      // 比较路径
      const currentPath = currentUrlObj.pathname.split('/');
      const linkPath = linkUrlObj.pathname.split('/');
      
      let pathScore = 0;
      const minLength = Math.min(currentPath.length, linkPath.length);
      for (let j = 0; j < minLength; j++) {
        if (currentPath[j] === linkPath[j]) {
          pathScore++;
        } else {
          break;
        }
      }
      score += pathScore;
      
      // 比较查询参数
      const currentParams = currentUrlObj.searchParams;
      const linkParams = linkUrlObj.searchParams;
      let paramScore = 0;
      
      currentParams.forEach((value, key) => {
        if (linkParams.has(key) && linkParams.get(key) === value) {
          paramScore++;
        }
      });
      score += paramScore * 0.5; // 参数匹配加分较少
      
      // 更新最佳匹配
      if (score > bestScore) {
        bestScore = score;
        bestMatch = link;
      }
    }
    
    return bestMatch;
  }
}
customElements.define('jxs-language-currency', JxsLanguageCurrency);


/* ----------------------------- Jxs Product Compare START ----------------------------------- */
class JxsProductCompare extends HTMLElement {
  constructor() {
    super()
    this.querySelector('button[name="search"]').addEventListener('click', this.onSearchSubmit.bind(this))
  }

  onSearchSubmit() {
    const currentUrl = new URL(window.location.href);
    currentUrl.search = '';
    const queryParams = new URLSearchParams();

    this.querySelectorAll('jxs-product-compare-filter-metafield').forEach(f => {
      const data = f.getSearchTerm()
      if (data?.name && data.values?.length) {
        const paramName = 'filter.p.m.' + data.name;
        data.values.forEach(value => {
          queryParams.append(paramName, value);
        });
      }
    })
    currentUrl.search = queryParams.toString();
    window.location.href = currentUrl.toString();
  }
}
customElements.define('jxs-product-compare', JxsProductCompare);

class JxsProductCompareFilterMetafield extends HTMLElement {
  constructor() {
    super()
    this.canMultiSelect = this.hasAttribute('multi-select')
    const onValueItemClickListener = this.onValueItemClick.bind(this)
    this.querySelectorAll('.filter-value').forEach(v => {
      v.addEventListener('click', onValueItemClickListener)
    })
    this.initSelectedValueFromUrlQuery()
  }

  get selectedValues() {
    return Array.from(this.querySelectorAll('.filter-value.selected')).map(item => item.dataset.value)
  }

  initSelectedValueFromUrlQuery() {
    const name = 'filter.p.m.' + this.dataset.metafieldName;
    const urlParams = new URLSearchParams(window.location.search);
    const values = urlParams.getAll(name); // 获取所有同名参数的值（数组）

    values.forEach(v => {
      // 解码 URL 编码的值（如 "%20" → " "）
      const decodedValue = decodeURIComponent(v);
      this.querySelector(`.filter-value[data-value="${decodedValue}"]`)?.classList.add('selected');
    });
  }

  onValueItemClick(e) {
    const value = e.target.closest('.filter-value')
    const isSelected = value.classList.contains('selected')

    if (!isSelected && !this.canMultiSelect) {
      this.querySelector('.filter-value.selected')?.classList.remove('selected')
    }
    value.classList.toggle('selected')
  }

  getSearchTerm() {
    return {
      name: this.dataset.metafieldName,
      values: this.selectedValues
    }
  }
}
customElements.define('jxs-product-compare-filter-metafield', JxsProductCompareFilterMetafield);

/* ----------------------------- Jxs Product Compare END ----------------------------------- */

/**
 * 监听元素进入 / 离开视口。
 *
 * @param {Object} [options]
 * @param {Element|string} [options.el]
 * @param {boolean} [options.once=true]
 * @param {(entry: IntersectionObserverEntry) => void} [options.enterCallback]
 * @param {(entry: IntersectionObserverEntry) => void} [options.leaveCallback]
 * @param {number} [options.enterPercent=0.1]
 * @param {number} [options.leavePercent]
 * @param {number} [options.delay=0] 进入后延迟执行 enterCallback，单位秒。
 * @returns {() => void}
 */
window.jxsInView = function jxsInView(options) {
  options = options || {};
  var el = options.el;
  var once = options.once !== false;
  var enterCallback = options.enterCallback;
  var leaveCallback = options.leaveCallback;
  var enterPercent = options.enterPercent;
  var leavePercent = options.leavePercent;
  var delay = options.delay;

  var element = typeof el === 'string' ? document.querySelector(el) : el;

  if (!element || element.nodeType !== 1) {
    console.warn('[jxsInView] 需要传入有效的 el。', el);
    return function () {};
  }

  if (!('IntersectionObserver' in window)) {
    console.warn('[jxsInView] 当前浏览器不支持 IntersectionObserver。');
    return function () {};
  }

  function clampRatio(value, fallback) {
    var number = Number(value);
    if (isNaN(number)) number = fallback;
    return Math.min(Math.max(number, 0), 1);
  }

  var enterRatio = clampRatio(enterPercent, 0.1);
  var leaveRatio = clampRatio(leavePercent === undefined ? enterRatio : leavePercent, enterRatio);
  var enterDelay = Math.max(Number(delay) || 0, 0);
  var thresholds = [0, enterRatio, leaveRatio, 1].filter(function (ratio, index, list) {
    return list.indexOf(ratio) === index;
  }).sort(function (a, b) { return a - b; });

  var isInView = false;
  var isDestroyed = false;
  var enterTimer = 0;
  var observer;

  function enter(entry) {
    if (isInView) return;
    isInView = true;

    var runEnterCallback = function () {
      enterTimer = 0;
      if (isDestroyed) return;
      if (typeof enterCallback === 'function') enterCallback(entry);
    };

    if (enterDelay > 0) {
      enterTimer = window.setTimeout(runEnterCallback, enterDelay * 1000);
    } else {
      runEnterCallback();
    }

    if (once) {
      observer.unobserve(element);
      observer.disconnect();
    }
  }

  function leave(entry) {
    if (!isInView) return;
    isInView = false;
    if (enterTimer) {
      window.clearTimeout(enterTimer);
      enterTimer = 0;
    }
    if (typeof leaveCallback === 'function') leaveCallback(entry);
  }

  observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (!entry) return;
    var ratio = entry.intersectionRatio;

    if (!isInView && entry.isIntersecting && ratio >= enterRatio) {
      enter(entry);
      return;
    }

    if (!once && isInView && (!entry.isIntersecting || ratio <= leaveRatio)) {
      leave(entry);
    }
  }, {
    threshold: thresholds,
  });

  observer.observe(element);

  return function () {
    isDestroyed = true;
    if (enterTimer) {
      window.clearTimeout(enterTimer);
      enterTimer = 0;
    }
    observer.unobserve(element);
    observer.disconnect();
  };
};